<template>
  <v-container grid-list-xl fluid>
    <!-- dsoto  12-12-2022-->

    <v-container>
      <v-layout>
        <v-flex xs12 md4>
          <v-select
            v-model="periodoValue"
            :items="periodoSelect"
            label="Periodo"
            data-vv-name="listaPeriodos"
          ></v-select>
        </v-flex>

        <v-flex xs12 md4>
          <v-select
            v-model="proveedorValue"
            :items="proveedorSelect"
            label="Proveedor"
            item-text="nombre"
            item-value="code"
          ></v-select>
        </v-flex>

        <!--
        <v-flex xs12 md4>
          <v-select 
            v-model="procesoValue" 
            :items="procesoSelect" 
            label="Item"
          ></v-select>
        </v-flex>      
        -->

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar evolucionnn"
          @click="filter()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
    </v-container>

    <!-- dsoto  12-12-2022  -->

    <v-layout>
      <v-flex>
        <div v-if="loading">
          <loading></loading>
        </div>
        <div v-if="showAlert == true">
          <alert-empty></alert-empty>
        </div>
        <v-widget
          v-if="dataProductos == true"
          class="px-0"
          :key="indexChart"
          :title="tituloGrafica"
          content-bg="white"
        >
          <div slot="widget-content">
            <e-chart
              :path-option="[
                ['dataset.source', res],
                [
                  'color',
                  [
                    color.lightBlue.base,
                    color.orange.base,
                    color.grey.base,
                    color.red.base,
                  ],
                ],
                ['legend.show', true],
                ['xAxis.axisLabel.show', true],
                ['yAxis.axisLabel.show', true],
                ['grid.left', '2%'],
                ['grid.bottom', '5%'],
                ['grid.right', '3%'],
                ['series[0].type', 'bar'],
                ['series[0].areaStyle', {}],
                ['series[0].smooth', true],
                ['series[1].type', 'bar'],
                ['series[1].areaStyle', {}],
                ['series[1].smooth', true],
                ['series[2].type', 'bar'],
                ['series[2].areaStyle', {}],
                ['series[2].smooth', true],
                ['series[3].type', 'bar'],
                ['series[3].areaStyle', {}],
                ['series[3].smooth', true],
              ]"
              height="400px"
              width="100%"
            ></e-chart>
          </div>
        </v-widget>
      </v-flex>
    </v-layout>

    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn
        v-if="botonDescarga == true"
        color="primary"
        @click="downloadData()"
        >Descarga</v-btn
      >
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-container>
</template>

<script>
import API from "@/api";
import Util from "@/util";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import axios from "axios";
import { mapState } from "vuex";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  components: {
    VWidget,
    EChart,
    CircleStatistic,
    Loading,
    AlertEmpty,
  },
  mixins: [misMixins],
  props: {},
  data: () => ({
    dataPorcentaje: false,
    dataProductos: false,
    showAlert: false,
    loading: false,
    color: Material,
    contratoId: "",
    selectedTab: "tab-1",
    pruebasImd: [],
    pruebasProductos: [],
    pruebasMateriales: [],
    pruebasVisitas: [],
    dataReady: false,
    res: "",
    indexChart: 0,
    btnHidden: true,
    botonHidden: false,
    subProceso: "",
    tituloGrafica: "",
    id: "",

    // 12-12-2022
    periodoSelect: [],
    periodoValue: null,
    proveedorSelect: [],
    proveedorValue: null,
    itemsProveedor: [],
    botonDescarga: false,
  }),
  computed: {},
  created() {
    this.id = this.$route.params.id;

    this.periodoValue = new Date().getFullYear();
    for (let i = parseInt(2019); i <= parseInt(this.periodoValue); i++) {
      this.periodoSelect.push(i);
    }

    this.proveedores();
    this.filter();
  },
  mounted() {},

  methods: {
    filter() {
      //alert(this.id + " ID");

      if (this.id == 1) {
        this.dataProductos = false;
        this.loadData();
      } else if (this.id == 3) {
        this.dataProductos = true;
        this.tituloGrafica = "Aprobación de productos";
        this.loadDataProductos();
      } else if (this.id == 6) {
        this.dataProductos = false;
        this.loadDataMateriales();
      } else if (this.id == 7) {
        this.dataProductos = true;
        this.loadDataVisitas();
      }
    },

    async loadData() {
      this.loading = true;
      //dibujar la grafica
      this.botonDescarga = false; //dsoto
      this.pruebasImd = [];
      this.pruebasImd = await this.loadFilter();

      if (this.pruebasImd.length > 0) {
        this.dataProductos = true;
        this.botonDescarga = true; //dsoto
        this.showAlert = false;
        this.chartData();
      } else {
        //this.showAlert=true;
      }
      this.loading = false;
    },
    chartData() {
      this.tituloGrafica =
        "Porcentaje de avance de impresión, mecanizado y distribución";
      let data = [];
      this.pruebasImd.forEach((m) => {
        data.push({
          niveles: m.nivel,
          Impresión: m.porcenImpresion.toFixed(2),
          Mecanizado: m.porcenMecanizado.toFixed(2),
          Distribución: m.porcenDistribucion.toFixed(2),
          "": "",
        });
      });
      this.res = data;
      this.indexChart += 1;
    },
    async loadFilter() {
      if (this.periodoValue != null && this.proveedorValue != null) {
        //dsoto
        return await axios
          .get(
            "/reportes/porcentaje/avance/imdp/" +
              this.periodoValue +
              "/" +
              this.proveedorValue
          )
          .then(function (response) {
            return response.data;
          })

          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        //dsoto
        return await axios
          .get("/reportes/porcentaje/avance/imd/" + this.periodoValue)
          .then(function (response) {
            return response.data;
          })

          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      }
    },

    // dsoto 14-12-2022
    async proveedores() {
      this.itemsProveedor = [];
      this.itemsProveedor = await this.loadProveedor();

      if (this.itemsProveedor.length > 0) {
        this.loadProveedorSelect();
      } else {
        this.showAlert = true;
      }
    },

    async loadProveedor() {
      let proceso = "";

      if (this.id == 1) {
        proceso = "IMPRESIÓN";
      }
      if (this.id == 6) {
        proceso = "APLICACION";
      }

      return await axios
        //  .get("/proveedores")
        .get("/proveedoresProceso/" + proceso)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadProveedorSelect() {
      let niv = [];
      this.itemsProveedor.forEach(function (c) {
        let index = niv.findIndex((x) => x.id == c.id);
        console.log(c.razonSocial);
        console.log(c.id);

        if (index === -1) {
          if (c.id != null && c.id != "") {
            niv.push({ nombre: c.razonSocial, code: c.id });
          }
        }
      });
      this.proveedorSelect = niv;
    },
    // dsoto 14-12-2022

    async loadProductos() {
      if (this.periodoValue != null && this.proveedorValue != null) {
        return await axios
          .get(
            "/reportes/validaciones/productosprov/" +
              this.periodoValue +
              "/" +
              this.proveedorValue
          )
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        return await axios
          .get("/reportes/validaciones/productos/" + this.periodoValue)
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      }
    },
    async loadDataProductos() {
      this.loading = true;
      this.botonDescarga = false; //dsoto
      //dibujar la grafica
      this.pruebasProductos = [];
      this.pruebasProductos = await this.loadProductos();
      this.loading = false;
      if (this.pruebasProductos.length > 0) {
        this.botonDescarga = true; //dsoto
        this.showAlert = false;
        this.chartDataProductos();
      } else {
        //this.showAlert=true;
      }
      this.loading = false;
    },
    chartDataProductos() {
      this.tituloGrafica = "Porcentaje de avance de productos";
      let data = [];
      this.pruebasProductos.forEach((m) => {
        data.push({
          items: "Item " + m.item,
          Entregada: m.entregada,
          Observada: m.observada,
          Presentada: m.presentada,
          Validada: m.validada,
        });
      });
      this.res = data;
      this.indexChart += 1;
    },

    async loadMateriales() {
      if (this.periodoValue != null && this.proveedorValue != null) {
        return await axios
          .get(
            "/reportes/revisionMaterialesProv/" +
              this.periodoValue +
              "/" +
              this.proveedorValue
          )
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        return await axios
          .get("/reportes/revisionMateriales/" + this.periodoValue)
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      }
    },
    async loadDataMateriales() {
      this.loading = true;
      this.botonDescarga = false; //dsoto
      //dibujar la grafica
      this.pruebasMateriales = [];
      this.pruebasMateriales = await this.loadMateriales();
      this.loading = false;

      if (this.pruebasMateriales.length > 0) {
        this.dataProductos = true;
        this.botonDescarga = true; //dsoto
        this.showAlert = false;
        this.chartDataMateriales();
      } else {
        //this.showAlert=true;
      }
      this.loading = false;
    },

    chartDataMateriales() {
      this.tituloGrafica = "Porcentaje de avance de Materiales";
      let data = [];

      this.pruebasMateriales.forEach((m) => {
        data.push({
          niveles: m.nivel,
          Recepción: m.porcen_cursos_recepcionados.toFixed(2),
          Revisión: m.porcen_cursos_revisados.toFixed(2),
          "": "",
          "": "",
        });
      });
      this.res = data;
      this.indexChart += 1;
    },

    async loadVisitas() {
      if (this.periodoValue != null && this.proveedorValue != null) {
        return await axios
          .get(
            "/reportes/visitasPreviasProv/" +
              this.periodoValue +
              "/" +
              this.proveedorValue
          )
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        //alert("periodo");

        return await axios
          .get("/reportes/visitasPrevias/" + this.periodoValue)
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.dataProductos = false;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      }
    },
    async loadDataVisitas() {
      this.loading = true;
      this.botonDescarga = false; //dsoto
      //dibujar la grafica
      this.pruebasVisitas = [];
      this.pruebasVisitas = await this.loadVisitas();
      this.loading = false;
      if (this.pruebasVisitas.length > 0) {
        this.botonDescarga = true; //dsoto
        this.showAlert = false;
        this.chartDataVisitas();
      } else {
        //this.showAlert=true;
      }
      this.loading = false;
    },
    chartDataVisitas() {
      this.tituloGrafica = "Porcentaje de avance de visitas";
      let data = [];
      this.pruebasVisitas.forEach((m) => {
        data.push({
          niveles: m.nivel,
          Aprobado: m.porcen_aprobada.toFixed(2),
          Pendiente: m.porcen_pendiente.toFixed(2),
          "": "",
          "": "",
        });
        this.indexChart += 1;
      });
      this.res = data;
    },

    //dsoto
    clear() {
      this.proveedorValue = null;
      this.botonDescarga = false;
      this.periodoValue = new Date().getFullYear();
      this.dataProductos = false;
      //this.loadData();
    },

    downloadData() {
      //alert(this.id);

      if (this.id == 1) {
        this.dialogLoading = true;
        let filename = "Reporte_avance_(IMP_MEC_DIST).xlsx";

        if (this.proveedorValue == null) {
          this.proveedorValue = 0;
        }

        axios({
          url:
            "/reportes/avanceIMDExcel/" +
            this.periodoValue +
            "/" +
            this.proveedorValue,
          method: "GET",
          responseType: "blob",
        })
          .then(function (response) {
            const urle = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = urle;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
            return [];
          });
      }

      if (this.id == 3) {
        this.dialogLoading = true;
        let filename = "Reporte_aprobacion_acuerdos.xlsx";

        axios({
          url:
            "/reportes/acuerdosExcel/" +
            this.periodoValue +
            "/" +
            this.proveedorValue,
          method: "GET",
          responseType: "blob",
        })
          .then(function (response) {
            const urle = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = urle;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
            return [];
          });
      }

      if (this.id == 6) {
        this.dialogLoading = true;
        let filename = "Reporte_avance_materiales.xlsx";

        if (this.proveedorValue == null) {
          this.proveedorValue = 0;
        }

        axios({
          url:
            "/reportes/materialesExcel/" +
            this.periodoValue +
            "/" +
            this.proveedorValue,
          method: "GET",
          responseType: "blob",
        })
          .then(function (response) {
            const urle = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = urle;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
            return [];
          });
      }
    },
  },
};
</script>
